import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';

export default function MyProntoOrders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        fetch('/api/my-pronto-orders')
            .then(res => res.json())
            .then(data => {
                setOrders(Array.isArray(data) ? data : []);
                setLoading(false);
            })
            .catch(() => {
                setError('Failed to load Pronto orders');
                setLoading(false);
            });
    }, []);

    return (
        <div>
            {loading && <div>Loading...</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            {!loading && !error && (
                <Table striped bordered hover size="sm" className="mt-3">
                    <thead>
                        <tr>
                            <th>Order No</th>
                            <th>Date</th>
                            <th>Customer</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th>Order Ref</th>
                            <th>Print</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.length === 0 ? (
                            <tr><td colSpan={99} className="text-center">No Pronto orders found.</td></tr>
                        ) : orders.map((order, idx) => (
                            <tr key={`pronto-order-${idx}`}>
                                <td>{order.orderNo || '—'}</td>
                                <td>{order.date || ''}</td>
                                <td>{order.customerName || '—'}</td>
                                <td>{order.email || ''}</td>
                                <td>{order.phone || ''}</td>
                                <td>{order.status || ''}</td>
                                <td>{order.orderId || ''}</td>
                                <td className="text-center align-middle">
                                    {order.prontoSO ? (
                                        <button
                                            className="btn btn-primary btn-sm"
                                            title="Open a printable Order Confirmation in a new tab"
                                            onClick={() => window.open('/api/print-sales-order?so=' + encodeURIComponent(order.prontoSO) + (order.rep ? '&rep=' + encodeURIComponent(order.rep) : '') + '&sig=' + encodeURIComponent(order.sig || ''), '_blank')}
                                        >
                                            Print
                                        </button>
                                    ) : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
}
